import React, { useState, useRef, Fragment } from "react";
import { Box, Typography, Stack, Grid } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import LoadingButton from "@mui/lab/LoadingButton";
import "react-toastify/dist/ReactToastify.css";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Link from "next/link";
import { TextField } from "@mui/material";
import { nanoid } from "nanoid";
import axios from "axios";
import darkTheme from "../src/theme";
import ReCAPTCHA from "react-google-recaptcha";
import { useRouter } from "next/router";
import Head from "next/head";

const cardContainer = {
  borderRadius: 3,
  marginTop: darkTheme.spacing(6),
  padding: darkTheme.spacing(4),
  boxShadow: darkTheme.shadows[8],
  background: darkTheme.palette.background.alternate,
  border: `1px solid ${darkTheme.palette.background.ticket}`,
  textAlign: "left",
  [darkTheme.breakpoints.down("md")]: {
    marginTop: darkTheme.spacing(0),
    marginBottom: darkTheme.spacing(0),
  },
  "& h3": {
    fontSize: 20,
    color: darkTheme.palette.common.white,
    fontWeight: 600,
    marginBottom: darkTheme.spacing(1),
  },
  "& h5": {
    fontSize: 16,
    color: darkTheme.palette.primary.tickets,
    fontWeight: 400,
    marginBottom: darkTheme.spacing(0.5),
  },
  "& h6": {
    fontSize: 14,
    color: darkTheme.palette.background.dates,
    fontWeight: 400,
    marginBottom: darkTheme.spacing(0.5),
  },
  "& a": {
    color: darkTheme.palette.primary.dates,
    ":hover": {
      // color: darkTheme.palette.common.white
      textDecoration: "underline",
      color: `${darkTheme.palette.primary.main} !important`,
    },
    "& :hover": {
      // color: darkTheme.palette.common.white
      textDecoration: "underline",
      color: `${darkTheme.palette.primary.main} !important`,
    },
  },
};

const formContainer = {
  marginTop: darkTheme.spacing(3),
  marginBottom: darkTheme.spacing(5),
  [darkTheme.breakpoints.down("md")]: {
    marginTop: darkTheme.spacing(1),
    marginBottom: darkTheme.spacing(5),
  },
};

function Contact() {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [subject, setSubject] = useState("For Customer Queries");
  const [message, setMessage] = useState("");

  const Router = useRouter();

  const captchaRef = useRef(null);

  const handleChangeName = (event) => {
    setName(event.target.value);
  };

  const handleChangeEmail = (event) => {
    setEmail(event.target.value);
  };

  const handleChangeMobile = (event) => {
    setMobile(event.target.value);
  };

  const handleChangeSubject = (event) => {
    setSubject(event.target.value);
  };

  const handleChangeMessage = (event) => {
    setMessage(event.target.value);
  };

  const onSubmitContact = async (event) => {
    event.preventDefault();
    setLoading(true);
    const data = {
      mobile: mobile,
      email: email,
      name: name,
      subject: subject,
      message: message,
    };
    if (!data.name) {
      toast.error(`Please Enter Name`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      setLoading(false);
    } else if (!data.email) {
      toast.error(`Please Enter Valid Email ID`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      setLoading(false);
    } else if (!data.mobile) {
      toast.error(`Please Enter Valid Mobile Number`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      setLoading(false);
    } else if (!data.subject) {
      toast.error(`Please Enter Subject`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      setLoading(false);
    } else if (!data.message) {
      toast.error(`Please Enter Message`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      setLoading(false);
    } else {
      // alert(data.mobile.length)
      if (data.mobile.length != 10) {
        toast.error(`Please Enter Valid Mobile Number`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setLoading(false);
      } else if (data.email.indexOf('@') <= 0 || data.email.indexOf('.') <= 0) {
        toast.error(`Please Enter Valid Email ID`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setLoading(false);
      } else {
        setLoading(true);
        const token = captchaRef.current.getValue();
        data.token = token;
        captchaRef.current.reset();
        axios
          .post(
            `/api/auth/contact`,
            { data: data },
            {
              headers: {
                "x-auth-token": process.env.JWT_TOKEN,
              },
            }
          )
          .then((response) => {
            if (response.status == 200) {
              setLoading(false);
              if (response.data.status == 0) {
                toast.error(`Something Went Wrong`, {
                  position: toast.POSITION.BOTTOM_CENTER,
                });
              } else {

                if (email) {
                  axios.post(`${process.env.BACKSTAGE_APP_SERVER}/api/messaging/sendEmail/contactConfirmation`,
                    {
                      "toAddress": email,
                      "toName": name ? name : 'User'
                    },
                    {
                      headers: {
                        'x-auth-token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE2OTI4NjYyNDF9.slCFZbe5TOJr2rSjRSQWevopQnyXhnqB1EFcNOfFl28'
                      }
                    }
                  ).then((response) => {
                    console.log(response);
                  })
                }

                toast.success(`Form has been Submitted Successfully!`, {
                  position: toast.POSITION.BOTTOM_CENTER,
                });
                setName("");
                setEmail("");
                setMobile("");
                setSubject("For Customer Queries");
                setMessage("");
                Router.push("/thanks");
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  const subjects = [
    {
      value: "For Customer Queries",
      label: "For Customer Queries",
    },
    {
      value: "For Business enquiries",
      label: "For Business enquiries",
    },
    {
      value: "For Media/Press enquiries",
      label: "For Media/Press enquiries",
    },
    {
      value: "For other enquiries",
      label: "For other enquiries",
    },
    {
      value: "I want to host my event on Clubr",
      label: "I want to host my event on Clubr",
    },
  ];

  return (
    <Fragment>
      <Head>
        <title>Clubr-Contact Us</title>
        <meta name="description" content="Clubr-Contact Us"></meta>
        <meta property="og:title" content="Clubr-Contact Us<"></meta>
        <meta property="og:description" content="Clubr-Contact Us"></meta>
        <meta
          property="og:image"
          content="https://clubrstorage.blob.core.windows.net/clubr-img/OGImageHome.jpg"
        ></meta>
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Clubr" />
        <meta property="og:url" content={`https://clubr.in/contact`} />
      </Head>
      <Typography component="div" sx={{ pt: 18 }}>
        <Grid container spacing={0}>
          <Grid item xs={1}>
            &nbsp;
          </Grid>
          <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
            <Grid container spacing={10}>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                className="mobileMode"
              >
                <Typography component="div" sx={cardContainer}>
                  <Typography
                    component="div"
                    sx={{
                      mb: 2,
                      pb: 2,
                      borderBottom: `1px dotted ${darkTheme.palette.background.ticket}`,
                    }}
                  >
                    <Typography variant="h3">Address</Typography>
                    <Typography variant="h5">
                      Clubr Technoligies Private limited
                    </Typography>
                    <Typography variant="h6" sx={{ pb: 2 }}>
                      2ND FLOOR, 8-2-695/E/4A ROCK HOUSE, ROAD NO 12,
                      BANJARAHILLS, Hyderabad, Hyderabad, Telangana, 500034.
                    </Typography>
                    <Typography component="h6">
                      <Link href="tel:04066396639" passHref>
                        <a>
                          <PhoneIcon
                            sx={{
                              color: darkTheme.palette.grey[400],
                              fontSize: 16,
                            }}
                          />
                          &nbsp;+91 40 6639 6639
                        </a>
                      </Link>
                    </Typography>
                    {/* <Typography component="h6">
                        <Link href="tel:917993793579" passHref>
                            <a><PhoneIcon sx={{ color: darkTheme.palette.grey[400], fontSize:16 }} />&nbsp;+91 7993793579</a>
                        </Link>                           
                    </Typography> */}
                  </Typography>

                  <Typography variant="h3">Follow Us</Typography>
                  <Stack display="flex" flexDirection="row">
                    <Link href="https://www.facebook.com/Clubrapp">
                      <a target="_blank">
                        <FacebookIcon
                          sx={{ color: darkTheme.palette.grey[400], mr: 4 }}
                        />
                      </a>
                    </Link>
                    <Link href="https://www.instagram.com/clubr.in/">
                      <a target="_blank">
                        <InstagramIcon
                          sx={{ color: darkTheme.palette.grey[400], mr: 4 }}
                        />
                      </a>
                    </Link>
                    <Link href="https://www.linkedin.com/company/clubrapp">
                      <a target="_blank">
                        <LinkedInIcon
                          sx={{ color: darkTheme.palette.grey[400], mr: 4 }}
                        />
                      </a>
                    </Link>
                  </Stack>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography variant="h3">Hello, Lets get in touch</Typography>
                <Box component="div" sx={formContainer}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    id="name"
                    label="Full Name"
                    type="text"
                    sx={{
                      mb: darkTheme.spacing(3),
                      background: `${darkTheme.palette.background.default} !imrpotant`,
                    }}
                    onChange={handleChangeName}
                    value={name}
                  />
                  <TextField
                    variant="outlined"
                    fullWidth
                    id="mobile"
                    label="Mobile"
                    type="number"
                    sx={{
                      mb: darkTheme.spacing(3),
                      background: `${darkTheme.palette.background.default} !imrpotant`,
                    }}
                    onChange={handleChangeMobile}
                    value={mobile}
                  />
                  <TextField
                    variant="outlined"
                    fullWidth
                    id="email"
                    label="Email"
                    type="email"
                    sx={{
                      mb: darkTheme.spacing(3),
                      background: `${darkTheme.palette.background.default} !imrpotant`,
                    }}
                    onChange={handleChangeEmail}
                    value={email}
                  />

                  <TextField
                    variant="outlined"
                    id="subject"
                    fullWidth
                    select
                    label="Select Reason"
                    value={subject}
                    onChange={handleChangeSubject}
                    SelectProps={{
                      native: true,
                    }}
                    sx={{
                      mb: darkTheme.spacing(3),
                      background: `${darkTheme.palette.background.default} !imrpotant`,
                    }}
                  >
                    {subjects.map((option) => (
                      <option key={nanoid(30)} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                  <TextField
                    variant="outlined"
                    fullWidth
                    id="message"
                    label="Message"
                    multiline
                    rows={4}
                    sx={{
                      mb: darkTheme.spacing(3),
                      background: `${darkTheme.palette.background.default} !imrpotant`,
                    }}
                    onChange={handleChangeMessage}
                    value={message}
                  />
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_SITE_KEY}
                    ref={captchaRef}
                  />
                  <Typography
                    component="div"
                    sx={{ mt: darkTheme.spacing(1), textAlign: "center" }}
                  >
                    <LoadingButton
                      variant="contained"
                      className="themeBtn"
                      onClick={onSubmitContact}
                      loading={loading}
                      size="large"
                      type="submit"
                      loadingPosition="end"
                      color="primary"
                    >
                      Submit
                    </LoadingButton>
                  </Typography>
                  <ToastContainer position={toast.POSITION.BOTTOM_LEFT} />
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                className="desktopMode"
              >
                <Typography component="div" sx={cardContainer}>
                  <Typography
                    component="div"
                    sx={{
                      mb: 2,
                      pb: 2,
                      borderBottom: `1px dotted ${darkTheme.palette.background.ticket}`,
                    }}
                  >
                    <Typography variant="h3">Address</Typography>
                    <Typography
                      variant="h5"
                      sx={{
                        mb: 1,
                        fontSize: 16,
                        fontWeight: 400,
                        color: darkTheme.palette.primary.tickets,
                      }}
                    >
                      Clubr Technoligies Private limited
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        pb: 2,
                        fontSize: 14,
                        fontWeight: `100 !important`,
                        color: darkTheme.palette.primary.dates,
                      }}
                    >
                      2ND FLOOR, 8-2-695/E/4A ROCK HOUSE, ROAD NO 12,
                      BANJARAHILLS, Hyderabad, Hyderabad, Telangana, 500034.
                    </Typography>
                    {/* <Typography component="h6">
                      <Link href="tel:04066396639" passHref>
                        <a>
                          <PhoneIcon
                            sx={{
                              color: darkTheme.palette.grey[400],
                              fontSize: 16,
                            }}
                          />
                          &nbsp;+91 40 6639 6639
                        </a>
                      </Link>
                    </Typography> */}
                    {/* <Typography component="h6">
                      <Link href="tel:917993793579" passHref>
                        <a>
                          <PhoneIcon
                            sx={{
                              color: darkTheme.palette.grey[400],
                              fontSize: 16,
                            }}
                          />
                          &nbsp;+91 7993793579
                        </a>
                      </Link>
                    </Typography> */}
                  </Typography>

                  <Typography variant="h3">Follow Us</Typography>
                  <Stack display="flex" flexDirection="row">
                    <Link href="https://www.facebook.com/Clubrapp">
                      <a target="_blank">
                        <FacebookIcon
                          sx={{ color: darkTheme.palette.grey[400], mr: 4 }}
                        />
                      </a>
                    </Link>
                    <Link href="https://www.instagram.com/clubr.in/">
                      <a target="_blank">
                        <InstagramIcon
                          sx={{ color: darkTheme.palette.grey[400], mr: 4 }}
                        />
                      </a>
                    </Link>
                    <Link href="https://www.linkedin.com/company/clubrapp">
                      <a target="_blank">
                        <LinkedInIcon
                          sx={{ color: darkTheme.palette.grey[400], mr: 4 }}
                        />
                      </a>
                    </Link>
                  </Stack>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={1}>
            &nbsp;
          </Grid>
        </Grid>
      </Typography>
    </Fragment>
  );
}

export default Contact;
